var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { config } from '@imtbl/sdk';
var appEnvMap = {
    live: {
        collectionAddress: '0xa04bcac09a3ca810796c9e3deee8fdc8c9807166',
        holderWalletAddress: '0x908c64f48f34de7f2303a1fcbb0a6437282f99e6',
        feeAddress: '0x2ff3ba7616c083edaecfac2cc9d2a48073f6c004',
        metadataUrl: 'https://imx.crosstheages.com/metadata',
        imxConfig: config.Environment.PRODUCTION,
        ctaTokenAddress: '0x90685e300a4c4532efcefe91202dfe1dfd572f47',
        imxApiUrl: 'https://api.x.immutable.com/v1',
        magicLinkApiKey: 'pk_live_DC29A65A3D8E3BCC',
        blockchainNetwork: 'mainnet',
        ctaTokenHolderShopWalletAddress: '0xb04d8e87d87de79fda0af8f66b1aad06ccf33023',
        registrationContractAddress: '0x72a06bf2a1CE5e39cBA06c0CAb824960B587d64c',
        starkContractAddress: '0x5fdcca53617f4d2b9134b29090c87d01058e27e9',
        usdcTokenAddress: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
        imxTokenAddress: '0xf57e7e7c23978c3caec3c3548e3d615c346e79ff',
        immutascanUrl: 'https://immutascan.io/address',
    },
    testing: {
        collectionAddress: '0x9cae6987c185e1d6a54efa6917fdadf72694faee',
        holderWalletAddress: '0x032d93a9f6fd2c390c17a56568bf18600dc6c98c',
        feeAddress: '0xcf94347ab55c0047dd14e54edcd901f600d1d0b3',
        imxConfig: config.Environment.SANDBOX,
        metadataUrl: 'https://cta-tcg-imx-testing.s3.eu-west-3.amazonaws.com/metadata',
        ctaTokenAddress: '0x6da2a4d37259439c7ddcddb55cd0ef2033fe1e8f',
        imxApiUrl: 'https://api.sandbox.x.immutable.com/v1',
        magicLinkApiKey: 'pk_live_83936566D9123D25',
        blockchainNetwork: 'testnet',
        ctaTokenHolderShopWalletAddress: '0xec7b7d2d048a905ddbc0147e8fbf970a3091555a',
        registrationContractAddress: '0xDbA6129C02E69405622fAdc3d5A7f8d23eac3b97',
        starkContractAddress: '0x2d5C349fD8464DA06a3f90b4B0E9195F3d1b7F98',
        usdcTokenAddress: '0x1291070c5f838dccdddc56312893d3efe9b372a8',
        imxTokenAddress: '0xe2629e08f4125d14e446660028bd98ee60ee69f2',
        immutascanUrl: 'https://sandbox.immutascan.io/address',
    },
    dev: {
        collectionAddress: '0x9cae6987c185e1d6a54efa6917fdadf72694faee',
        holderWalletAddress: '0x032d93a9f6fd2c390c17a56568bf18600dc6c98c',
        feeAddress: '0xcf94347ab55c0047dd14e54edcd901f600d1d0b3',
        imxConfig: config.Environment.SANDBOX,
        metadataUrl: 'https://cta-tcg-imx-testing.s3.eu-west-3.amazonaws.com/metadata',
        ctaTokenAddress: '0x6da2a4d37259439c7ddcddb55cd0ef2033fe1e8f',
        imxApiUrl: 'https://api.sandbox.x.immutable.com/v1',
        magicLinkApiKey: 'pk_live_83936566D9123D25',
        blockchainNetwork: 'testnet',
        ctaTokenHolderShopWalletAddress: '0xec7b7d2d048a905ddbc0147e8fbf970a3091555a',
        registrationContractAddress: '0xDbA6129C02E69405622fAdc3d5A7f8d23eac3b97',
        starkContractAddress: '0x2d5C349fD8464DA06a3f90b4B0E9195F3d1b7F98',
        usdcTokenAddress: '0x1291070c5f838dccdddc56312893d3efe9b372a8',
        imxTokenAddress: '0xe2629e08f4125d14e446660028bd98ee60ee69f2',
        immutascanUrl: 'https://sandbox.immutascan.io/address',
    },
    dev1: {
        collectionAddress: '0x9cae6987c185e1d6a54efa6917fdadf72694faee',
        holderWalletAddress: '0x032d93a9f6fd2c390c17a56568bf18600dc6c98c',
        feeAddress: '0xcf94347ab55c0047dd14e54edcd901f600d1d0b3',
        imxConfig: config.Environment.SANDBOX,
        metadataUrl: 'https://cta-tcg-imx-testing.s3.eu-west-3.amazonaws.com/metadata',
        ctaTokenAddress: '0x6da2a4d37259439c7ddcddb55cd0ef2033fe1e8f',
        imxApiUrl: 'https://api.sandbox.x.immutable.com/v1',
        magicLinkApiKey: 'pk_live_83936566D9123D25',
        blockchainNetwork: 'testnet',
        ctaTokenHolderShopWalletAddress: '0xec7b7d2d048a905ddbc0147e8fbf970a3091555a',
        registrationContractAddress: '0xDbA6129C02E69405622fAdc3d5A7f8d23eac3b97',
        starkContractAddress: '0x2d5C349fD8464DA06a3f90b4B0E9195F3d1b7F98',
        usdcTokenAddress: '0x1291070c5f838dccdddc56312893d3efe9b372a8',
        imxTokenAddress: '0xe2629e08f4125d14e446660028bd98ee60ee69f2',
        immutascanUrl: 'https://sandbox.immutascan.io/address',
    },
    dev2: {
        collectionAddress: '0x9cae6987c185e1d6a54efa6917fdadf72694faee',
        holderWalletAddress: '0x032d93a9f6fd2c390c17a56568bf18600dc6c98c',
        feeAddress: '0xcf94347ab55c0047dd14e54edcd901f600d1d0b3',
        imxConfig: config.Environment.SANDBOX,
        metadataUrl: 'https://cta-tcg-imx-testing.s3.eu-west-3.amazonaws.com/metadata',
        ctaTokenAddress: '0x6da2a4d37259439c7ddcddb55cd0ef2033fe1e8f',
        imxApiUrl: 'https://api.sandbox.x.immutable.com/v1',
        magicLinkApiKey: 'pk_live_83936566D9123D25',
        blockchainNetwork: 'testnet',
        ctaTokenHolderShopWalletAddress: '0xec7b7d2d048a905ddbc0147e8fbf970a3091555a',
        registrationContractAddress: '0xDbA6129C02E69405622fAdc3d5A7f8d23eac3b97',
        starkContractAddress: '0x2d5C349fD8464DA06a3f90b4B0E9195F3d1b7F98',
        usdcTokenAddress: '0x1291070c5f838dccdddc56312893d3efe9b372a8',
        imxTokenAddress: '0xe2629e08f4125d14e446660028bd98ee60ee69f2',
        immutascanUrl: 'https://sandbox.immutascan.io/address',
    },
    local: {
        // Live data
        collectionAddress: '0xa04bcac09a3ca810796c9e3deee8fdc8c9807166',
        holderWalletAddress: '0x908c64f48f34de7f2303a1fcbb0a6437282f99e6',
        feeAddress: '0xe11ff52ee2b0abe406273c9a6174aa0eb3c5ca8b',
        metadataUrl: 'https://imx.crosstheages.com/metadata',
        imxConfig: config.Environment.PRODUCTION,
        ctaTokenAddress: '0x90685e300a4c4532efcefe91202dfe1dfd572f47',
        imxApiUrl: 'https://api.x.immutable.com/v1',
        magicLinkApiKey: 'pk_live_DC29A65A3D8E3BCC',
        blockchainNetwork: 'mainnet',
        ctaTokenHolderShopWalletAddress: '0xb04d8e87d87de79fda0af8f66b1aad06ccf33023',
        registrationContractAddress: '0x72a06bf2a1CE5e39cBA06c0CAb824960B587d64c',
        starkContractAddress: '0x5fdcca53617f4d2b9134b29090c87d01058e27e9',
        usdcTokenAddress: '0x1291070c5f838dccdddc56312893d3efe9b372a8',
        imxTokenAddress: '0xe2629e08f4125d14e446660028bd98ee60ee69f2',
        immutascanUrl: 'https://immutascan.io/address',
        // Local data
        // collectionAddress: '0x1011682adf1186163c5de99a903e28743b5dcbf1',
        // holderWalletAddress: '0x54f111513b399db637989edfd43d2b782f6b036a',
        // feeAddress: '0x54f111513b399db637989edfd43d2b782f6b036a',
        // imxConfig: config.Environment.SANDBOX,
        // metadataUrl: 'https://cta-tcg-imx-local.s3.eu-west-3.amazonaws.com/metadata',
        // ctaTokenAddress: '0x6da2a4d37259439c7ddcddb55cd0ef2033fe1e8f',
        // imxApiUrl: 'https://api.sandbox.x.immutable.com/v1',
        // magicLinkApiKey: 'pk_live_83936566D9123D25',
        // blockchainNetwork: 'testnet',
        // ctaTokenHolderShopWalletAddress: '0xec7b7d2d048a905ddbc0147e8fbf970a3091555a',
        // registrationContractAddress: '0xDbA6129C02E69405622fAdc3d5A7f8d23eac3b97',
        // starkContractAddress: '0x2d5C349fD8464DA06a3f90b4B0E9195F3d1b7F98',
        // immutascanUrl: 'https://sandbox.immutascan.io/address',
    },
};
var common = {
    isLocal: process.env.REACT_APP_ENV === 'local',
    isLive: process.env.REACT_APP_ENV === 'live',
    isTesting: process.env.REACT_APP_ENV === 'testing',
    isDev: process.env.REACT_APP_ENV === 'dev',
    isDev1: process.env.REACT_APP_ENV === 'dev1',
    isDev2: process.env.REACT_APP_ENV === 'dev2',
    blockchain: appEnvMap[process.env.REACT_APP_ENV || ''],
    marketplaceImagesUrl: {
        card: 'https://imx.crosstheages.com/image/card/',
        cardArtwork: 'https://crosstheages.com/cdn-cgi/image/width=280,quality=100/https://cdn.crosstheages.com/card-artwork/',
        cardAvatar: 'https://imx.crosstheages.com/image/avatar/avatar-character-',
        mintPass: 'https://imx.crosstheages.com/image/mint-pass/',
        mintPassBackground: 'https://imx.crosstheages.com/image/mint-pass-background/',
        souvenirCard: 'https://imx.crosstheages.com/image/souvenir-card/',
        presalePack: 'https://imx.crosstheages.com/image/presale-pack/',
        presaleTicket: 'https://imx.crosstheages.com/image/presale-ticket/',
        chest: 'https://imx.crosstheages.com/image/chest/',
        shard: 'https://imx.crosstheages.com/image/shard/',
        ariseCoin: 'https://imx.crosstheages.com/image/arise-coin/',
        profileBanner: 'https://imx.crosstheages.com/image/profile-banner/',
        shop: 'https://imx.crosstheages.com/image/shop/',
    },
    ctaTokenAddress: appEnvMap[process.env.REACT_APP_ENV || ''].ctaTokenAddress,
    usdcTokenAddress: appEnvMap[process.env.REACT_APP_ENV || ''].usdcTokenAddress,
    imxTokenAddress: appEnvMap[process.env.REACT_APP_ENV || ''].imxTokenAddress,
    ctaTokenHolderShopWalletAddress: appEnvMap[process.env.REACT_APP_ENV || ''].ctaTokenHolderShopWalletAddress,
    immutascanUrl: appEnvMap[process.env.REACT_APP_ENV || ''].immutascanUrl,
    openSeaApiKey: '94abf5961b77494581ddeb959e773f48',
};
export var appEnv = __assign({}, common);
